const formValidation = {
  errorMessages: {
    email: 'Please enter a valid email.',
    firstName: 'Please enter a first name.',
    lastName: 'Please enter a last name.',
    phoneNumber: 'Please enter a phone number.',
    school: 'Please enter a school name.',
    ethnicity: 'Please select an ethnicity.',
    dob: 'Please enter a date of birth.',
    gradeLevel: 'Please enter a grade level.',
  },
};

export default formValidation;
